import PropTypes from 'prop-types';

export const locationType = PropTypes.shape({
  id: PropTypes.string,
  address1: PropTypes.string,
  address2: PropTypes.string,
  city: PropTypes.string,
  postCode: PropTypes.string,
  country: PropTypes.string,
  continent: PropTypes.string,
});
